module.exports = __webpack_public_path__ + "static/media/UPPSCH2.e02c8b7b.jpg";